import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sw-cabn8-materials-reset-dialog',
  templateUrl: './cabn8-materials-reset-dialog.component.html',
  styleUrls: ['./cabn8-materials-reset-dialog.component.scss'],
})
export class Cabn8MaterialsResetDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<Cabn8MaterialsResetDialogComponent>
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
